import { render, staticRenderFns } from "./BankIdLoginButton.vue?vue&type=template&id=2389bb04&scoped=true"
import script from "./BankIdLoginButton.vue?vue&type=script&lang=js"
export * from "./BankIdLoginButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2389bb04",
  null
  
)

export default component.exports